"use strict";import{tag as r}from"../custom-tag.js";export function liveChatIcon({height:a=16,width:e=16,hidden:l=!1,title:t="Live chat"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="live-chat_svg__mask0_6875_6640"
        width="20"
        height="19"
        x="2"
        y="3"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M2 11.159a1.17 1.17 0 0 1 1.171-1.171h10.735a1.17 1.17 0 0 1 1.171 1.17v6.823a1.17 1.17 0 0 1-1.171 1.17H8.412a1.2 1.2 0 0 0-.66.204L5.048 21.2a.703.703 0 0 1-1.098-.58v-.493a.974.974 0 0 0-.975-.974.974.974 0 0 1-.974-.975z"
        />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.975 3a1.17 1.17 0 0 0-1.171 1.171v4.264h5.2a1.5 1.5 0 0 1 1.5 1.5v2.158h4.325a1.17 1.17 0 0 0 1.17-1.171v-6.75A1.17 1.17 0 0 0 20.83 3z"
          clip-rule="evenodd"
        />
      </mask>
      <g mask="url(#live-chat_svg__mask0_6875_6640)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=liveChat.js.map
